<div class="input-with-operations">
  <input [type]="withViewButton && hidden ? 'password' : 'text'" [value]="value" readonly="readonly" />
  <div class="operations">
    <div class="operations-button" *ngIf="withViewButton">
      <img *ngIf="hidden" src="assets/images/common/view.svg" (click)="showSecretClicked()" />
      <img *ngIf="!hidden" src="assets/images/common/hide.svg" (click)="showSecretClicked()" />
    </div>
    <app-copy-button
      class="operations-button"
      [withCopyIcon]="true"
      [value]="value"
      [fixedSize]="false"
    ></app-copy-button>
  </div>
</div>
